<template>
    <div>
        <MainTheme>
            <!-- ./components/MainTheme.vue 를 가져옵니다.-->
        </MainTheme>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <!-- <h1 class="display-3  text-white">
                                    Discover Life's Beauty with Daom
                                </h1> -->
                                <span class="display-3  text-white">
                                    Discover
                                </span>
                                <span class="display-3" style="color:#ffafbd">
                                    Life's
                                </span>
                                <span class="display-3  text-white">
                                    Beauty with
                                </span>
                                <span class="display-3" style="color:#fffb00">
                                    Daom
                                </span>
                                
                                <p class="lead  text-white">
                                    <span>다옴과 함께하는 편안한 생활을 향한 공사</span>
                                    <br><span>모두 여기로 </span>
                                    <span class="font-weight-bold" style="color:#fffb00;">'다옴'</span>
                                </p>
                                <div class="btn-wrapper">
                                    <base-button tag="a"
                                                href="/reference"
                                                class="mb-3 mb-sm-0"
                                                type="info"
                                                icon="fa fa-area-chart">
                                                공사실적
                                    </base-button>
                                    <base-button tag="a"
                                                href="/customer"
                                                class="mb-3 mb-sm-0"
                                                type="white"
                                                icon="fa fa-envelope-open">
                                        견적문의
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-building" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">기업연혁</h6>
                                    <p class="description mt-3">다옴토건은 우수한 실력으로 현재까지 평가받고 있습니다. 토목 및 상하수도 공사까지 함께 ...</p>
                                    <div>
                                        <badge type="primary" rounded>우수기업</badge>
                                    </div>
                                    <base-button tag="a" href="/history" type="primary" class="mt-4">
                                        기업연혁 바로가기
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-briefcase" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">사업소개</h6>
                                    <p class="description mt-3">공사에 가장 중요한 첫 공사, 다옴토건만의 노하우를 토대로 토건사업을 진행하고 있습니다.</p>
                                    <div>
                                        <badge type="success" rounded>토목</badge>
                                        <badge type="success" rounded>상하수도</badge>
                                        <badge type="success" rounded>주요시공사</badge>
                                    </div>
                                    <base-button tag="a" href="/introduce" type="success" class="mt-4">
                                        사업소개 바로가기
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-handshake-o" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">사업제안</h6>
                                    <p class="description mt-3">여러가지 공사에 대하여 다옴토건이 친절하고 빠르게 답변해드립니다. 궁금한 사항을 언제든지 말씀해주세요.</p>
                                    <div>
                                        <badge type="warning" rounded>공사비용문의</badge>
                                        <badge type="warning" rounded>공사가능문의</badge>
                                        <badge type="warning" rounded>상하수도문의</badge>
                                    </div>
                                    <base-button tag="a" href="/qanda" type="warning" class="mt-4">
                                        Q&A 바로가기
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/main2.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="fa fa-paper-plane" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>편안한 공사접수</h3>
                            <p>이제 어려운 공사접수는 그만! 다옴에서는 인터넷으로 PC, 모바일로 편안하게 접수할 수 있어요. 전화는 물론 모바일로도 접수 가능! 모든 공사 여기서 다봄~ 역시 편안한 다옴답죠?</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="fa fa-desktop"></badge>
                                        <h6 class="mb-0">인터넷으로 간편하게 공사접수</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="fa fa-mobile"></badge>
                                        <h6 class="mb-0">공사견적도 모바일로 쉽게</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">인터넷으로 빠른 접수 가능</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/main3.png'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">고객만족공사</h4>
                                <p class="lead text-italic text-white">고객이 원하는 공사. <br>고객이 만족하는 완공. <br>수 많은 경험을 토대로 쌓여온 노하우를 통해 확실한 공사를 보장합니다.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>믿을 수 있는 시공</h3>
                            <p class="lead">공사에 가장 중요한 부분인 완공. 완벽한 공사를 위해서는 시공부터 잘해야합니다.</p>
                            <p>여러 공사를 성공적으로 마친 다옴. 얼마나 많은 노하우를 가졌길래 이렇게 성공적으로 공사를 할 수 있을까요?</p>
                            <p>비결은 수 많은 공사경험이 풍부한 인력에 있습니다. 다옴토건은 배테랑으로 구성된 인력을 바탕으로 토목, 건설, 상하수도 공사를 처음부터 확실하게 진행합니다.</p>
                            <p>역시 시공부터 고객마음이 편안한 다옴답죠?</p>
                            <a href="/reference" class="font-weight-bold text-warning mt-5">시공사례 바로가기</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">시공사례</h4>
                                <p class="text-white">다옴의 주요공사실적. 여기 다옴이 하고있는 일을 알려드려요.
                                    <br>
                                </p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-road" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">토목공사</h5>
                                    <p>토목 공사를 전문으로 하며, 안전하고 지속 가능한 인프라를 구축합니다.</p>
                                    <a href="/reference" class="text-success">토목 바로가기</a>
                                </div>
                            </div>
                        </card>
                        <!-- <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-industry" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">건축공사</h5>
                                    <p>다양한 건축공사를 전문으로 하며, 현대적이고 지속 가능한 건축물을 제작합니다.</p>
                                    <a href="/buscivil" class="text-warning">건축공사 바로가기</a>
                                </div>
                            </div>
                        </card> -->
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-stumbleupon" gradient="primary" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-primary">상하수도공사</h5>
                                    <p>상수 및 하수 시스템 설계와 구축, 비굴착을 전문으로 합니다.</p>
                                    <a href="/busconstruction" class="text-primary">상하수도 바로가기</a>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">주요공사고객</h2>
                        <p class="lead text-muted">다옴과 함께한 고객들입니다. 편안한 공사를 체험해 본 고객들의 사례.
                            <br>다음 공사도 역시 다옴과 함께면 든든하죠?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/customer-logo1.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 182px; max-height: 182px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">서울대학교</span>
                                    <small class="h6 text-muted">오수관로 보수공사</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/customer-logo2.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 182px; max-height: 182px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">서울보호관찰소</span>
                                    <small class="h6 text-muted">도로 포장공사</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/customer-logo3.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 182px; max-height: 182px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">동작구청</span>
                                    <small class="h6 text-muted">도로교통 소통 개선공사</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/customer-logo4.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 182px; max-height: 182px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">금천구청</span>
                                    <small class="h6 text-muted">공영 주차장 조성공사</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">믿을 수 있는 마음 편안한 공사</h3>
                                <p class="lead text-white mt-3">다옴과 함께하는 공사는 믿고 맡길 수 있습니다. 토목에서부터 상하수도 공사까지! 무엇을 하던 역시 다옴이죠!</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/reference"
                                             type="white" block size="lg">
                                    주요공사실적 보러가기
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-150">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">다옴은 이렇게 공사합니다</h2>
                        <p class="lead text-white">우수한 인재들을 바탕으로 꾸준히 성공적인 공사를 이어가는 다옴토건</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">안전한 작업환경</h5>
                        <p class="text-white mt-3">최고급 건설보호장비와 함께 안전수칙을 지켜가며 일합니다. 언제나 안.전.제.일!</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">정확한 자재관리</h5>
                        <p class="text-white mt-3">정확하게 측정하여 준비된 자재를 가지고 일합니다. 마치 딱 맞는 블록을 끼워마치는 듯한 깔끔한 자재사용.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-map-signs" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">기간엄수</h5>
                        <p class="text-white mt-3">현실적인 일정 조율로 공사기간을 정해서 일합니다. 버스가 제시간에 딱 오면 마음이 한결 편안하죠. </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">보수공사도 역시 다옴
                            <span class="text-success">마음놓고 보수공사 맡길 곳이 없을까?</span>
                        </h2>
                        <p class="lead">이미 지어진 건물이나 시설에 하자가 생기면 어떡하죠? 보수공사를 하고 또 보수를 해야할 상황이 오면 어쩌지? 공사를 잘하는 곳에 문의해야 할텐데.. 
                            <br>수 많은 경험을 가진 다옴이 보수공사 걱정을 날려버려드릴게요~
                            <br>이미 많은 고객들이 편안한 공사를 보장 해주는 다옴과 함께하고 있습니다.
                        </p>
                        <div class="btn-wrapper">
                            <a href="/reference"
                               class="btn btn-primary mb-3 mb-sm-0">보수공사 사례보기</a>
                        </div>
                        <div class="text-center">
                            <h4 class="display-4 mb-5 mt-5">여러 고객들과 함께 해요</h4>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="한국농수산식품유통공사">
                                        <img v-lazy="'img/theme/customer-logo14.png'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="서울시 서초구">
                                        <img v-lazy="'img/theme/customer-logo16.png'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="서울시 동작구청">
                                        <img v-lazy="'img/theme/customer-logo3.png'"
                                             class="img-fluid  opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="서울시 금천구청">
                                        <img v-lazy="'img/theme/customer-logo4.png'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="서울시 관악구청">
                                        <img v-lazy="'img/theme/customer-logo5.png'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a data-toggle="tooltip"
                                       data-original-title="서울시 광진구">
                                        <img v-lazy="'img/theme/customer-logo8.png'"
                                             class="img-fluid opacity-5">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 mb-5 mb-md-0 text-center">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="" title="현장갤러리">
                                <img v-lazy="'img/theme/gallery-1.png'" class="card-img">
                            </router-link>
                        </div>
                        <p class="lead">
                            개선공사 교통통제 현장
                        </p>
                    </div>
                    <div class="col-md-6 mb-5 mb-lg-0 text-center">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="" title="현장갤러리">
                                <img v-lazy="'img/theme/gallery-2.png'" class="card-img">
                            </router-link>
                        </div>
                        <p class="lead">
                            주상복합 신축공사 현장
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section pt-0 pb-0">
            <div class="container">
                <div class="row row-grid align-items-center my-md">
                    <div class="col-lg-6">
                        <h3 class="text-primary font-weight-light mb-2">걱정없는 편안한 공사</h3>
                        <h4 class="mb-0 font-weight-light">처음하는 공사. 새롭게 시작하는 공사.
                            <br>지금 다옴과 함께하세요.
                        </h4>
                    </div>
                    <div class="col-lg-6 text-lg-center btn-wrapper">
                        <a target="_blank" rel="noopener" href="/qanda"
                        class="btn btn-neutral btn-twitter btn-round btn-lg" data-toggle="tooltip"
                        data-original-title="Follow us">
                            문의하러가기
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import MainTheme from "./components/MainTheme";

export default {
  name: "home",
  components: {
    MainTheme
  }
};
</script>
